import React from "react";
import styled from "styled-components";
import TeamLogo from "./TeamLogo";

const StyledContainerDiv = styled.div`
  display: flex;
  align-items: center;
`;

const StyledTeamNameDiv = styled.div`
  padding: 0.25rem;
`;

export default function TeamLogoAndName({ team, week, size, linkPath }) {
  if (!team || !team.hasLoaded()) return null;

  return (
    <StyledContainerDiv>
      <TeamLogo team={team} week={week} size={size} linkPath={linkPath} />
      <StyledTeamNameDiv>{team.fullName}</StyledTeamNameDiv>
    </StyledContainerDiv>
  );
}
